<div [hidden]="urlInprogress">
  <!-- <img #uploadedImg *ngIf="extension !== 'pdf'" src="{{ url }}" [style.width.px]="imgWidth" /> -->
  <img *ngIf="extension !== 'pdf'" [style.width.px]="imgWidth" [src]="domSanitizer.bypassSecurityTrustResourceUrl(baseUrl)" />
  <div *ngIf="extension === 'pdf'">
    <!-- <iframe [src]="tempUrl" height="{{ imgHeight }}" width="{{ imgWidth }}px" frameborder="0"></iframe> -->

    <embed
      [attr.src]="domSanitizer.bypassSecurityTrustResourceUrl(baseUrl + '#toolbar=0&navpanes=0&scrollbar=0')"
      type="application/pdf"
      height="{{ imgHeight }}"
      width="{{ imgWidth }}px"
    />
  </div>
  <div *ngIf="downloadLink">
    <a class="txt-link" (click)="downloadAttachment(url)" target="_blank" rel="noopener noreferrer"> Download </a>
  </div>
</div>
<div class="loader" [hidden]="!urlInprogress"></div>
